export const GET_BARBER_REPORTS = 'GET_BARBER_REPORTS';
export const GET_BARBER_REPORT_SUMMARY = 'GET_BARBER_REPORT_SUMMARY';
export const SET_CSV = 'SET_CSV';
export const IMPORT_REPORT_APPOINTMENTS = 'IMPORT_REPORT_APPOINTMENTS';
export const LOAD_REPORT_APPOINTMENTS_PER_PAGE = 50;
export const SET_REPORTS_START_DATE = 'SET_REPORTS_START_DATE';
export const SET_REPORTS_END_DATE = 'SET_REPORTS_END_DATE';
export const SET_REPORTS_START_DATE_ISO = 'SET_REPORTS_START_DATE_ISO';
export const SET_REPORTS_END_DATE_ISO = 'SET_REPORTS_END_DATE_ISO';
export const RESET_REPORTS = 'RESET_REPORTS';
export const SET_BARBER_COMMISSION = 'SET_BARBER_COMMISION';
export const SET_BARBER_PRODUCT_COMMISSION = 'SET_BARBER_PRODUCT_COMMISSION';
export const GET_CUSTOMER_REPORT = 'GET_CUSTOMER_REPORT';
export const ADD_BARBER_FILTER_REPORT = 'ADD_BARBER_FILTER_REPORT';
export const REMOVE_BARBER_FILTER_REPORT = 'REMOVE_BARBER_FILTER_REPORT';
export const SHOW_ALL_BARBER_FILTERS_REPORT = 'SHOW_ALL_BARBER_FILTERS_REPORT';
export const HIDE_ALL_BARBER_FILTERS_REPORT = 'HIDE_ALL_BARBER_FILTERS_REPORT';
export const GET_DEPOSITS_REPORT = 'GET_DEPOSITS_REPORT';
export const CLEAR_DEPOSITS_REPORT = 'CLEAR_DEPOSITS_REPORT';
export const FETCH_PAYOUTS_REPORT = 'FETCH_PAYOUTS_REPORT';
export const FETCH_DAILY_PAYROLL_REPORT = 'FETCH_PAYOUTS_REPORT';
export const CLEAR_PAYOUTS_REPORT = 'CLEAR_PAYOUTS_REPORT';
export const FETCH_LAST_PAYOUT = 'FETCH_LAST_PAYOUT';
export const FETCH_PRODUCT_SALES_REPORT = 'FETCH_PRODUCT_SALES_REPORT';
export const UPDATE_PAYMENT_FILTER = 'UPDATE_PAYMENT_FILTER';
export const FETCH_PAYOUT_HISTORY = 'FETCH_PAYOUT_HISTORY';
export const UPDATE_STATUS_FILTER = 'UPDATE_STATUS_FILTER';
export const UPDATE_APPOINTMENT_BOOKED_BY_FILTER = 'UPDATE_APPOINTMENT_BOOKED_BY_FILTER';
export const UPDATE_APPOINTMENT_STATUS_FILTER = 'UPDATE_APPOINTMENT_STATUS_FILTER';
export const UPDATE_APPOINTMENT_PLATFORM_FILTER = 'UPDATE_APPOINTMENT_PLATFORM_FILTER';
export const SET_REPORT_FILTERS_DIRTY = 'SET_REPORT_FILTERS_DIRTY';
export const UPDATE_BRAND_FILTER = 'UPDATE_BRAND_FILTER';
export const UPDATE_BRAND_FILTER_SELECT_ALL = 'UPDATE_BRAND_FILTER_SELECT_ALL';
export const UPDATE_BRAND_FILTER_DESELECT_ALL = 'UPDATE_BRAND_FILTER_DESELECT_ALL';
export const FETCH_SERVICES_COUNT = 'FETCH_SERVICES_COUNT';
export const FETCH_DISCOUNT_AMOUNT = 'FETCH_DISCOUNT_AMOUNT';
export const UPDATE_SERVICE_FILTER = 'UPDATE_SERVICE_FILTER';
export const FETCH_BARBERS_FOR_FILTER = 'FETCH_BARBERS_FOR_FILTER';
export const SET_BARBER_FILTER = 'SET_BARBER_FILTER';
export const UPDATE_CATEGORY_FILTER = 'UPDATE_CATEGORY_FILTER';
export const CATEGORY_FILTER_SELECT_ALL = 'CATEGORY_FILTER_SELECT_ALL';
export const CATEGORY_FILTER_DESELECT_ALL = 'CATEGORY_FILTER_DESELECT_ALL';
export const GET_PAYOUT_REPORT_NO_COMMISSION_SPLIT = 'GET_PAYOUT_REPORT_NO_COMMISSION_SPLIT';
export const GET_LOAN_REPAYMENT_REPORT = 'GET_LOAN_REPAYMENT_REPORT';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_DATE_FILTERS = 'RESET_DATE_FILTERS';
export const UPDATE_PRODUCT_INVENTORY_ACTION_FILTER = 'UPDATE_PRODUCT_INVENTORY_ACTION_FILTER';
export const UPDATE_PRODUCT_CATEGORY_FILTER = 'UPDATE_PRODUCT_CATEGORY_FILTER';
export const UPDATE_PRODUCT_CATEGORY_FILTER_SELECT_ALL = 'UPDATE_PRODUCT_CATEGORY_FILTER_SELECT_ALL';
export const UPDATE_PRODUCT_CATEGORY_FILTER_DESELECT_ALL = 'UPDATE_PRODUCT_CATEGORY_FILTER_DESELECT_ALL';

export const grossSalesKinds = {
  default: 'default',
  grossSalesPlusTaxes: 'grossSalesPlusTaxes',
};

export const GME_BRAND_ID = 'c1e4e77f-1868-41f0-a79f-b071edf9e603';
